<div
  class="field__label"
  [class.with-reorder]="isReorderEnabled"
  [class.empty]="!parent().controls.length"
>
  <rt-heading variant="subheading dark">
    <rt-icon [name]="icon()" />
    {{ label() }}
  </rt-heading>
</div>
<div
  class="field__values"
  [class.with-reorder]="isReorderEnabled"
  [class.empty]="!parent().controls.length"
>
  <div
    class="field__values-list drag-boundary"
    [cdkDropListDisabled]="!isReorderEnabled"
    (cdkDropListDropped)="onDrop($event, parent().controls)"
    cdkDropList
  >
    @for (
      control of $any(parent()).controls;
      track trackByControl(index, control);
      let index = $index;
      let last = $last
    ) {
      <rt-candidate-profile-information-editor-group-entry
        [parent]="control"
        [editing]="editing()"
        [previewTpl]="previewTpl()"
        [autofocus]="control === focusedControl()"
        [placeholder]="placeholder()"
        [allowReorder]="isReorderEnabled"
        [isLast]="last"
        [editPhoneNumber]="editPhoneNumber()"
        [countryCode]="countryCode()"
        (blur)="blur.emit($event)"
        (remove)="removeControl.emit(index)"
        cdkDrag
        cdkDropListLockAxis="y"
        cdkDragBoundary=".drag-boundary"
      >
        @if (isReorderEnabled) {
          <rt-icon-button
            variant="plain"
            class="drag-handle"
            cdkDragHandle
            iconName="drag-handle"
            shape="square"
            margin-right-small-x
          />
        }
      </rt-candidate-profile-information-editor-group-entry>
    }
    @if (serverError) {
      <span class="error-server">
        {{ serverError }}
      </span>
    }
  </div>

  <div layout>
    @if (showAddButton()) {
      <rt-button
        variant="plain"
        [class.with-reorder]="isReorderEnabled"
        (click)="addControl.emit()"
        margin-top-small-x
      >
        <rt-icon name="add" />
        <span>{{ addLabel() }}</span>
      </rt-button>
    }
  </div>
</div>
